/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ColDef, GridOptions } from 'ag-grid-community';
import { isFunction, upperFirst } from 'lodash';
import { GridDefinition } from './grid-definition';

export abstract class ManualGridDefinition implements GridDefinition {
  protected columnDefs?: ColDef[];
  protected options?: GridOptions;

  build(): GridOptions {
    const columnDefs = this.getConfig<ColDef[]>('columnDefs');
    const options = this.getConfig<GridOptions>('gridOptions') || {};

    options.columnDefs = columnDefs;

    return options;
  }

  buildColumnDefs?(): ColDef[];

  buildGridOptions?(): GridOptions;

  private getConfig<T>(name: string): Maybe<T> {
    if (!name) {
      return;
    }

    const method = this[`build${upperFirst(name)}`];

    return isFunction(method) ? method.call(this) : this[name];
  }
}
